<template>
  <div>
    <booking-infor
      :booking-info="bookingInfo"
    ></booking-infor>
    <p class="mt-3">
      {{ abnormalAttendanceText }}
    </p>
    <v-text-field
      v-model="bookingInfo.abnormalAttendanceReason"
      hint="Reason"
      outlined
    ></v-text-field>
  </div>
</template>
<script setup>
import { ref, onMounted, toRefs } from 'vue'
import { watch } from 'fs'
import BookingInfor from './BookingInfo'

// import UserList from '@/components/UserSelector/UserList'

import { useStore } from '@/store'

const abnormalAttendanceReason = ref('')

const abnormalAttendanceText = 'Please input the reason for abnormal attendance.'

// const coachList = ref([])

const store = useStore()

// onMounted(() => {
//   store.dispatch('users/listCoach')
//     .then(result => {
//       console.log('listCoach result', result)
//       coachList.value.push(...result)
//     })
//     .catch(err => {
//       console.log('err', err)
//     })
// })

const props = defineProps({
  bookingInfo: {
    type: Object,
    default() {
      return {
        id: -1,
        bookingNo: 'BAM2200001',
        studentName: 'Paul Chan',
        location: 'Mong Kok',
        date: '2022-06-13',
        time: '15:00 ~ 16:00',
        abnormalAttendanceReason: '',
      }
    },
  },
})

const { bookingInfo } = toRefs(props)

function reset() {
  bookingInfo.abnormalAttendanceReason = ''
}

// const { bookingInfo } = toRefs(props)
// watch(bookingInfo.value.abnormalAttendanceReason, value => {
//   abnormalAttendanceReason.value = value
// })

defineExpose({ reset })
</script>
